module.exports = __webpack_public_path__ + "static/media/upArrow.9edfa603.svg";